import React, { FC, ReactElement } from 'react';
import { Navigate } from 'react-router';
import { useAuth } from '@unbooking/ui-auth';

interface Props {
  children: ReactElement;
}

export const ProtectedRoute: FC<Props> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to='/local-sign-in' replace />;
  }

  return children;
};
